export const possibleMajors = [
  'Agriculture',
  'Architecture',
  'Ethnic Studies',
  'Gender Studies',
  'Biology',
  'Biomedical Science',
  'Business / Management',
  'Marketing',
  'Communications',
  'Journalism',
  'Computer Science',
  'Information Technology',
  'Construction',
  'Education',
  'Teaching',
  'Engineering',
  'English',
  'Family Science',
  'Foreign Language',
  'Doctor / Medical / Dental',
  'History',
  'Criminal Justice',
  'Law / Lawyer / Legal Professions',
  'Liberal Arts',
  'General Studies',
  'Library Science',
  'Mathematics',
  'Statistics',
  'Mechanic / Technician',
  'Military / Army / Navy / Air Force',
  'Multidisciplinary Studies',
  'Interdisciplinary Studies',
  'Natural Resources',
  'Conservation',
  'Parks and Recreation',
  'Fitness Studies',
  'Leisure and Recreation',
  'Personal Services',
  'Public Health',
  'Health Sciences',
  'Culinary / Chef',
  'Philosophy',
  'Religious Studies',
  'Science',
  'Precision Production',
  'Psychology',
  'Public Administration',
  'Social Science',
  'Theology / Religious Vocation',
  'Transportation',
  'Visual Art',
  'Performing Art',
  'Other',
  'Undecided',
  'Radio / Television',
  'Military Science',
  'Basic Skills',
  'Equine Studies',
  'Marine Biology',
  'Accounting',
  'International Business',
  'Entrepreneurship',
  'Advertising',
  'Public Relations',
  'Web / Software Development',
  'Aerospace Engineering',
  'Chemical Engineering',
  'Civil Engineering',
  'Computer Engineering',
  'Electrical Engineering',
  'Mechanical Engineering',
  'Medical Technician',
  'Athletics',
  'Dentistry',
  'Medical Science',
  'Nursing',
  'Pharmacy',
  'Physical Therapy',
  'Sports Medicine',
  'Veterinarian',
  'App / Mobile Development',
  'Energy Technology',
  'Forestry',
  'Sports Management',
  'Chemistry',
  'Physics',
  'Childcare',
  'Financial Services',
  'Politics / Political Science',
  'Missionary',
  'Flight Training',
  'Dance',
  'Drama / Performing Arts',
  'Fashion',
  'Game Design',
  'Graphic Art',
  'Interior Design',
  'Music',
  'Photography',
];

export const possibleMajorsMap = possibleMajors.map((major) => ({label: major, value: major}));

// These dates correspond to: Oct 1, Feb 1, July 1
// Months are 0-indexed in JS.
export const transferTermCutoffs = () => {
  const today = new Date();
  const thisYear = today.getFullYear();
  return {
    Fall: new Date(thisYear, 9, 1),
    Spring: new Date(thisYear, 1, 1),
    Summer: new Date(thisYear, 6, 1),
  };
};
